import { createContext, useContext, useEffect, useState } from "react";
import axios from "axios"
const StockMpContext = createContext();

export const StockMpProvider = ({ children }) => {
  const [stockSausage, setStockSausage] = useState({
    previsaoVendas: 0,
    estoque: 0,
    previsaoProducao: 0,
    custoUnitario: 0,
    receitaProduto: 0,
    pesoCaixa: 1,
    preco: 0
  });
  const [stockChicken, setStockChicken] = useState();
  const [stockCutChicken, setStockCutChicken] = useState();
  const [stockFries, setStockFries] = useState();
  //   const [insumosSausage, setInsumosSausage] = useState([])

  // function getDataSausage() {

  // }

  useEffect(() => {
    const storagedIndustry = JSON.parse(localStorage.getItem('@App:industria'));
    if (!storagedIndustry) return

    axios.get(`https://sistemas.sisinfor.com.br/BusinessGameBack/api/estoque/obterEstoqueIndustria/7/${storagedIndustry?.industria}`)
      .then(response => {
        setStockSausage(response.data)
      })

    axios.get(`https://sistemas.sisinfor.com.br/BusinessGameBack/api/estoque/obterEstoqueIndustria/8/${storagedIndustry?.industria}`)
      .then(response => {
        setStockChicken(response.data)
      })

    axios.get(`https://sistemas.sisinfor.com.br/BusinessGameBack/api/estoque/obterEstoqueIndustria/9/${storagedIndustry?.industria}`)
      .then(response => {
        setStockCutChicken(response.data)
      })

    axios.get(`https://sistemas.sisinfor.com.br/BusinessGameBack/api/estoque/obterEstoqueIndustria/10/${storagedIndustry?.industria}`)
      .then(response => {
        setStockFries(response.data)
      })
    // setInfoSausage(infoSausage);
  }, []);
  return (
    <StockMpContext.Provider
      value={{
        stockSausage,
        setStockSausage,
        stockChicken,
        setStockChicken,
        stockCutChicken,
        setStockCutChicken,
        stockFries,
        setStockFries
      }}
    >
      {children}
    </StockMpContext.Provider>
  );
};

export const useStockMp = () => useContext(StockMpContext);
